import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaPhone, FaEnvelope, FaSearch, FaTimes } from "react-icons/fa";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import './Header.css';
import Header_Logo from '../images/tattva-logo-png.png';
import Popup_Img from '../images/tattva-logo-png.png';
import linkedin from '../images/linkedin.png';
import facebook from '../images/facebook.png';
import twitter from '../images/twitter.png';
import instagram from '../images/instagram.png';
import whatsapp from '../images/whatsapp.png';
import youtube from '../images/youtube.png'
import projects from '../data/ProjectsData';
import WhatsAppButton from "./WhatsAppButton";
// import { useLocation } from 'react-router-dom';


function Header() {

    const [showModal, setShowModal] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [formData, setFormData] = useState({ name: "", mobile: "", email: "", message: "" });
    const [loading, setLoading] = useState(false);
    const [showIntro, setShowIntro] = useState(false);
    const [introAccepted, setIntroAccepted] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    // Hide intro popup on privacy policy page
    useEffect(() => {
        if (location.pathname === '/privacy-policy') {
            setShowIntro(false);
        }
    }, [location.pathname]);

    // Intro disclaimer logic
    useEffect(() => {
        const hasSeenIntro = localStorage.getItem('tattva_intro_seen');
        if (!hasSeenIntro) {
            setShowIntro(true);
        } else {
            setIntroAccepted(true);
        }
    }, []);

    // Show enquiry modal after 3s only after intro accepted
    useEffect(() => {
        if (introAccepted && location.pathname === '/contact-us') {
            const timer = setTimeout(() => setShowModal(true), 3000);
            return () => clearTimeout(timer);
        }
    }, [introAccepted, location.pathname]);

    const handleIntroAgree = () => {
        localStorage.setItem('tattva_intro_seen', 'true');
        setShowIntro(false);
        setIntroAccepted(true);
    };

    useEffect(() => {
        const dropdowns = document.querySelectorAll('.dropdown-menu.show');
        dropdowns.forEach(menu => menu.classList.remove('show'));
        const toggles = document.querySelectorAll('.dropdown-toggle.show');
        toggles.forEach(toggle => {
            toggle.classList.remove('show');
            toggle.setAttribute('aria-expanded', 'false');
        });
        const collapseNavbar = document.querySelector('.navbar-collapse.show');
        if (collapseNavbar) {
            collapseNavbar.classList.remove('show');
        }
    }, [location]);

    const toggleSearch = () => setShowSearch(!showSearch);

    const handleSearch = (e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();

            const projectRoutes = {
                'flat': '/projects/flats',
                'flats': '/projects/flats',
                'villa': '/projects/villas',
                'villas': '/projects/villas',
                'plot': '/projects/plots',
                'plots': '/projects/plots',
                'commercial': '/projects/commercials',
                'commercials': '/projects/commercials'
            };

            const matchedProject = projects.find(project =>
                project.project_name.toLowerCase().includes(query)
            );

            if (matchedProject) {
                navigate(`/projects/${matchedProject.id}`);
            } else {
                const matchedRoute = Object.keys(projectRoutes).find(key =>
                    query.includes(key)
                );
                if (matchedRoute) {
                    navigate(projectRoutes[matchedRoute]);
                } else {
                    navigate('/projects/flats');
                }
            }

            setSearchQuery("");
            setShowSearch(false);
        }
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch(
                "https://peracause.com/backend-files/tattva/contact-tattva.php",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    body: new URLSearchParams(formData).toString()
                }
            );
            const result = await response.json();
            alert(result.message);

            if (result.status === "success") {
                setFormData({ name: "", mobile: "", email: "", message: "" });
            }
        } catch (error) {
            alert("There was an error submitting the form.");
        }

        setLoading(false);
    };

    const handleCloseModal = () => setShowModal(false);

    return (
        <header>
            {/* Top Bar */}
            <div className="header-top py-2 container-fluid d-flex justify-content-center bg-dark">
                <div className="container d-flex align-items-center row">
                    <div className="d-flex justify-content-around col-lg-9 col-md-8 col-4">
                        <a href="mailto:support@tattvarealty.co.in" className="header-contact text-light d-flex align-items-center">
                            <FaEnvelope className="me-2" />
                            <span className="d-md-block d-none">support@tattvarealty.co.in</span>
                        </a>
                        <div className="d-flex gap-3 align-items-center">
                            <a href="tel:+918897035800" className="header-phone text-light d-flex align-items-center">
                                <FaPhone className="me-2" />
                                <span className="d-md-block d-none">+91 88970 35800</span>
                            </a>
                            <p className="text-white mb-0">|</p>
                            <a href="tel:+918897035800" className="header-phone text-light d-flex align-items-center">
                                <FaPhone className="me-2" />
                                <span className="d-md-block d-none">+91 73966 0274</span>
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-8 d-flex justify-content-end">
                        <div className="header-social d-flex align-items-center gap-1">
                            <a href="https://whatsapp.com/channel/0029Va6Bzio1NCrLOiBprT2e" target="_blank" rel="noreferrer"><img src={whatsapp} alt="LinkedIn" className="w-50" /></a>
                            <a href="https://www.linkedin.com/in/tattva-hi-life-735094319/" target="_blank" rel="noreferrer"><img src={linkedin} alt="LinkedIn" className="w-50" /></a>
                            <a href="https://x.com/TattvaHiLife" target="_blank" rel="noreferrer"><img src={twitter} alt="Twitter" className="w-50" /></a>
                            <a href="https://www.facebook.com/profile.php?id=100086552704523" target="_blank" rel="noreferrer"><img src={facebook} alt="Facebook" className="w-50" /></a>
                            <a href="https://www.instagram.com/tattvahilife_international/" target="_blank" rel="noreferrer"><img src={instagram} alt="Instagram" className="w-50" /></a>
                            <a href="https://www.youtube.com/" target="_blank" rel="noreferrer"><img src={youtube} alt="Instagram" className="w-75" /></a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Logo + Navbar */}
            <div className="header-middle bg-black text-light py-1">
                <div className="container d-flex justify-content-between align-items-center">
                    <Link to="/" className="header-logo">
                        <img src={Header_Logo} alt="Tattva Logo" className="img-fluid" />
                    </Link>

                    <nav className="navbar navbar-expand-lg navbar-dark">
                        <div className="container-fluid">
                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarNav">
                                <ul className="navbar-nav ms-auto">
                                    <li className="nav-item"><NavLink exact="true" className="nav-link" to="/">Home</NavLink></li>
                                    <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown">Projects</a>
                                        <ul className="dropdown-menu">
                                            <li><NavLink className="dropdown-item" to="/projects/flats">Flats</NavLink></li>
                                            <li><NavLink className="dropdown-item" to="/projects/villas">Villas</NavLink></li>
                                            <li><NavLink className="dropdown-item" to="/projects/plots">Plots</NavLink></li>
                                            <li><NavLink className="dropdown-item" to="/projects/commercials">Commercial</NavLink></li>
                                        </ul>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown">Locations</a>
                                        <ul className="dropdown-menu">
                                            <li><NavLink className="dropdown-item" to="/hyderabad">Hyderabad</NavLink></li>
                                            <li><NavLink className="dropdown-item" to="/dubai">Dubai</NavLink></li>
                                            <li><NavLink className="dropdown-item" to="/banglore">Bangalore</NavLink></li>
                                            <li><NavLink className="dropdown-item" to="/pune">Pune</NavLink></li>
                                            <li><NavLink className="dropdown-item" to="/mumbai">Mumbai</NavLink></li>
                                            <li><NavLink className="dropdown-item" to="/delhiNCR">Delhi NCR</NavLink></li>
                                        </ul>
                                    </li>
                                    <li className="nav-item"><NavLink className="nav-link" to="https://zamindaar.co.in/landowner-share" target="_blank">Landowner Share</NavLink>
                                    </li>
                                    <li className="nav-item"><NavLink className="nav-link" to="/facility-management">Facility Management</NavLink></li>
                                    <li className="nav-item"><NavLink className="nav-link" to="/about">About Us</NavLink></li>
                                    <li className="nav-item"><NavLink className="nav-link" to="/contact-us">Contact Us</NavLink></li>
                                    <button onClick={toggleSearch} className="btn text-rose ms-3" aria-label="Search"><FaSearch /></button>
                                </ul>
                            </div>
                        </div>
                    </nav>

                    <div className="d-none d-lg-block">
                        <button className="btn enquire-btn text-rose" onClick={() => setShowModal(true)}>
                            <span className='fs-3'>→</span> Enquire Now
                        </button>
                    </div>
                </div>
            </div>

            {/* Search Overlay */}
            {showSearch && (
                <div className="search-overlay position-fixed top-0 start-0 w-100 h-100 bg-black bg-opacity-75 d-flex justify-content-center align-items-start z-3">
                    <div className="search-container position-relative w-100 bg-black p-3">
                        <form onSubmit={handleSearch} className="d-flex justify-content-center align-items-center">
                            <input type="text" className="form-control me-2" placeholder="Search projects..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={{ maxWidth: '300px' }} autoFocus />
                            <button type="submit" className="btn text-rose"><FaSearch /></button>
                            <button type="button" className="btn text-rose ms-2" onClick={toggleSearch}><FaTimes /></button>
                        </form>
                    </div>
                </div>
            )}

            {/* Form Modal */}
            {showModal && (
                <div className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-body row p-4 flex-wrap-reverse">
                                <div className="col-lg-4 d-flex align-items-center justify-content-center">
                                    <div className="text-center">
                                        <img src={Popup_Img} alt="Support" className="mb-3" style={{ width: '100px', height: '100px' }} />
                                        <h4 className="text-rose">+91 988970 35800</h4>
                                        <p className="text-secondary">Make a call</p>
                                    </div>
                                </div>
                                <div className="divider col-lg-1 d-none d-lg-block"><div className="vertical-line"></div></div>
                                <div className="col-lg-7 position-relative d-flex align-items-center">
                                    <div className="position-absolute end-0 top-0" onClick={handleCloseModal}>
                                        <i className="fas fa-times text-rose fs-3 cursor-pointer"></i>
                                    </div>
                                    <div className="w-100">
                                        <form onSubmit={handleSubmit}>
                                            <h4 className="mb-4 text-rose">Enquire Now</h4>
                                            <input type="text" name="name" value={formData.name} placeholder="Enter your Name" onChange={handleChange} className="form-control mb-3" required />
                                            <input type="text" name="mobile" value={formData.mobile} placeholder="Enter your Phone Number" onChange={handleChange} className="form-control mb-3" required />
                                            <input type="email" name="email" value={formData.email} placeholder="Enter your Email" onChange={handleChange} className="form-control mb-3" required />
                                            <textarea name="message" value={formData.message} placeholder="Type your message here" rows="3" onChange={handleChange} className="form-control mb-3" required></textarea>
                                            <div className="text-start mt-3 d-flex align-items-center">
                                                <span className="fs-3 me-2 text-rose">→</span>
                                                <button type="submit" className="btn border-0 text-rose enquire-btn" disabled={loading}>
                                                    {loading ? "Sending..." : "Submit"}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Intro Disclaimer Popup */}
            {showIntro && (
                <>
                    {/* Black Overlay */}
                    <div className="intro-overlay position-fixed top-0 start-0 w-100 h-100 bg-black bg-opacity-75 z-3"></div>

                    {/* Centered Popup */}
                    <div className="intro-popup position-fixed top-50 start-50 translate-middle bg-white text-dark p-4 p-md-5 rounded shadow z-5" style={{ maxWidth: '700px', width: '90%', zIndex: 1050 }}>
                        <div className="text-center">
                            <h5 className="fw-bold mb-3 text-rose sine-title">Welcome to www.tattvarealty.co.in</h5>
                            <p className="small text-secondary text-start" style={{ lineHeight: '1.6' }}>
                                Thank you for visiting us. Please read the following carefully and note that this Disclaimer applies to the entire website.<br /><br />
                                The website is being updated as per TS RERA rules and regulations.<br /><br />
                                Therefore, by accessing any section of the website, you confirm your understanding that the information including images, details, brochures and marketing collaterals, etc. on this website are for informational purposes only.<br /><br />
                                All information is subject to change from time to time and you are advised to cross-verify the facts with our authorized sales representatives only.<br /><br />
                                Nothing on this website constitutes advertising, marketing, booking, selling or an offer for sale, or invitation to purchase a unit in any project listed here.<br /><br />
                                The Company is not liable for any consequence of any action taken by your relying on such material/information on this website.
                            </p>
                            <p className="small mt-3">
                                We use cookies to ensure you get the best experience on our website.{" "}
                                <Link to="/privacy-policy" className="text-decoration-underline text-rose">Learn more</Link>
                            </p>
                            <button onClick={handleIntroAgree} className="btn btn-rose mt-3 px-4">
                                I Agree
                            </button>
                        </div>
                    </div>
                </>
            )}


        </header>
    );
}

export default Header;
